import MultipleSelectForm from './MultipleSelectForm';
import MaxAnswerInput from './MaxAnswerInput';

export default MultipleSelectForm;
export { MaxAnswerInput };
